module.exports = __webpack_public_path__ + "static/media/section-cat-img-1.21f32d76.png";